@use "Styles/includes/variables";
@use "Styles/mixins" as mixins;

:host {
    box-sizing: border-box;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: variables.$fontQuaternary;

    width: 100vw;
    margin-left: calc(50% - 50vw);
    padding-inline: 16px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    // Reserve un-clipped space above and below the pills for the popover
    // panels inside `vm-video-share-menu` and `vm-video-save-menu` to open
    // into.
    //
    // `overflow-x: auto` above coerces `overflow-y` to `auto` too (CSS
    // spec), which would clip a popover panel opening from a pill. But
    // `overflow` clips at the padding-box edge, not the content edge — so
    // padding is inside the un-clipped region. Adding vertical padding
    // gives the panels somewhere to open without being cut off, and the
    // matching negative margins pull the container back to its natural
    // visual position so the rest of the page doesn't shift.
    //
    // 320px is picked to fit the tallest realistic panel content: the
    // save menu with a full playlist list (~280px) plus a small buffer.
    // Bump if a menu ever grows past that.
    padding-top: 320px;
    padding-bottom: 320px;
    margin-top: -320px;
    margin-bottom: -320px;

    @include mixins.desktop-and-up {
        // Three pills fit comfortably inside the column on desktop; no bleed or hole needed.
        width: auto;
        margin-left: 0;
        margin-top: 0;
        margin-bottom: 0;
        padding-inline: 0;
        padding-top: 0;
        padding-bottom: 0;
        overflow-x: visible;
    }
}

:host > * {
    flex-shrink: 0;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}
